<template>
    <div class="fill-height d-flex flex-column">
<!--No Farm Selected-->
        <div class="d-flex align-center justify-center fill-height flex-column" v-if="!selectedFarm">
            <v-icon x-large class="mb-4 grey--text">mdi-tractor-variant</v-icon>
            <span class="grey--text text-h6">Please select a farm to continue</span>
        </div>

<!--Range Selection-->
        <template v-else>
            <div class="d-flex align-stretch">

                <div style="width: 300px" class="d-flex flex-column justify-center align-center ml-2">
                    <v-autocomplete
                            :loading="loadingDescriptions"
                            label="Select Job Description"
                            v-model="selectedDescription"
                            :items="jobDescriptions"
                            :hide-details="true"
                            :full-width="true"
                            color="primary"
                            class="ma-0 pa-0"
                            dense
                            prefix="Desc: "
                            :outlined="true"
                            @change="getReportData"
                    >
                    </v-autocomplete>

                    <div class="d-flex justify-space-around" style="width: 100%">
<!--                        <v-btn-->
<!--                                :disabled="!selectedDescription || loadingReportData"-->
<!--                                @click="getReportData"-->
<!--                                color="primary"-->
<!--                                small-->
<!--                                :loading="loadingReportData"-->
<!--                        >-->
<!--                            Generate-->
<!--                        </v-btn>-->

                        <v-btn
                                :disabled="!selectedDescription || exportingData"
                                @click="exportReportData"
                                color="primary"
                                small
                                :loading="exportingData"
                        >
                            Export
                        </v-btn>
                    </div>


                </div>
                <div class="flex-grow-1 pl-5 pr-2 pt-2">

                    <div class="">
                        <span class="grey--text">Range:</span> {{rangeDisplay}}
                    </div>

                    <v-slider
                            :value="selectedRangeIndex"
                            @change="setRangeDate($event)"
                            :min="0"
                            :max="maxTicks"
                            thumb-label
                            ticks
                            :tick-labels="intervalLabels"
                    >

                        <template v-slot:prepend>
                            <v-icon
                                    color="primary"
                                    @click="setRangeDate(selectedRangeIndex - 1)"
                            >
                                mdi-minus
                            </v-icon>
                        </template>

                        <template v-slot:append>
                            <v-icon
                                    color="primary"
                                    @click="setRangeDate(selectedRangeIndex + 1)"
                            >
                                mdi-plus
                            </v-icon>
                        </template>

                    </v-slider>
                </div>
            </div>

            <div class="pt-4">
                <v-divider></v-divider>
            </div>

            <div class="flex-grow-1 d-flex align-center justify-center" v-if="loadingReportData">
                <loader :size="50"></loader>
            </div>

            <template v-else>


                <div class="flex-grow-1 of-y">

                    <!--                hide-default-footer-->
                    <v-data-iterator
                            :items="reportData"
                            class="fill-height d-flex flex-column"
                            :search="search"
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                    >
                                            <template v-slot:header>
                                                <v-toolbar
                                                        dark
                                                        color="grey lighten-3"
                                                        class="mb-1 flex-grow-0 flex-shrink-1"
                                                        height="52"
                                                >
                                                    <v-text-field
                                                            light
                                                            v-model="search"
                                                            dense
                                                            clearable
                                                            flat
                                                            solo
                                                            hide-details
                                                            prepend-inner-icon="mdi-magnify"
                                                            label="Search"
                                                    ></v-text-field>
                                                    <template v-if="$vuetify.breakpoint.mdAndUp">
                                                        <v-spacer></v-spacer>
                                                        <v-select
                                                                light
                                                                v-model="sortBy"
                                                                flat
                                                                dense
                                                                solo
                                                                hide-details
                                                                :items="keys"
                                                                item-text="description"
                                                                item-value="key"
                                                                prepend-inner-icon="mdi-magnify"
                                                                label="Sort by"
                                                        ></v-select>
                                                        <v-spacer></v-spacer>
                                                        <v-btn-toggle
                                                                v-model="sortDesc"
                                                                mandatory
                                                        >
                                                            <v-btn
                                                                    small
                                                                    depressed
                                                                    color="primary"
                                                                    :value="false"
                                                            >
                                                                <v-icon>mdi-arrow-up</v-icon>
                                                            </v-btn>
                                                            <v-btn
                                                                    small
                                                                    depressed
                                                                    color="primary"
                                                                    :value="true"
                                                            >
                                                                <v-icon>mdi-arrow-down</v-icon>
                                                            </v-btn>
                                                        </v-btn-toggle>
                                                    </template>
                                                </v-toolbar>
                                            </template>

                        <template v-slot:default="props">
                            <v-row no-gutters class="flex-grow-1 of-y grey lighten-3">
                                <v-col
                                        v-for="item in props.items"
                                        :key="item.name"
                                        cols="12"
                                        sm="8"
                                        md="6"
                                        lg="4"
                                >
                                    <v-card class="ma-2" hover>
                                        <v-card-title class="py-1 px-3 d-flex align-center">
                                            <div class="flex-grow-1 body-1 font-weight-bold">
                                                {{ item.name }}
                                            </div>
                                            <div class="grey--text body-2 font-weight-bold">
                                                {{ item.empCode }}
                                            </div>
                                        </v-card-title>
                                        <v-divider></v-divider>

                                        <v-simple-table dense>
                                            <template v-slot:default>
                                                <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Date
                                                    </th>
                                                    <th class="text-left">
                                                        In
                                                    </th>
                                                    <th class="text-left">
                                                        Out
                                                    </th>
                                                    <th class="text-left">
                                                        DWT
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                        v-for="day in item.rows"
                                                        :key="day.day"
                                                >
                                                    <td>{{ format(new Date(day.day), 'yyyy-MM-dd') }}</td>
                                                    <td>{{ day.start ? format(new Date(day.start), 'HH:mm') : '-' }}</td>
                                                    <td>{{ day.end ? format(new Date(day.end), 'HH:mm') : '-'}}</td>
                                                    <td class="font-weight-medium text-right">{{ day.hours.toFixed(1) }}</td>
                                                </tr>

                                                <tr>
                                                    <td colspan="4">
                                                        <div class="d-flex justify-space-between">
                                                            <div class="flex-grow-1 flex-equal text-center">Sunday Hours: <strong>{{ +item.sundayHours.toFixed(1) }}</strong></div>
                                                            <div class="flex-grow-1 flex-equal text-center">Overtime Hours: <strong>{{ +item.overtimeHours.toFixed(1) }}</strong></div>
                                                            <div class="flex-grow-1 flex-equal text-center">Standard Hours: <strong>{{ +item.standardHours.toFixed(1) }}</strong></div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-iterator>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import {addDays, eachWeekOfInterval, endOfDay, format, getDay, getYear, lastDayOfYear} from "date-fns";
import Loader from "../General/Loader/Loader";
import {mapGetters} from "vuex";

export default {
    components: {Loader},

    props: {
        viewStart: Date,
        selectedFarm: Number,
    },
    data() {
        return {
            loadingDescriptions: false,
            jobDescriptions: [],
            selectedDescription: null,
            format: format,
            loadingReportData: false,
            reportData: null,
            search: null,
            sortBy: 'name',
            keys: [{description: 'Name', key: 'name'}, {description: 'Employee Code', key: 'empCode'}, {description: 'Total Hours', key: 'total'}],
            sortDesc: false,
            exportingData: false
        }
    },
    watch: {
        selectedFarm: {
            immediate: true,
            handler(val) {
                this.jobDescriptions = [];
                this.selectedDescription = null;

                if (val)
                    this.loadDescriptionsForFarm();
            }
        },

        viewStart(val) {
            if (val && this.selectedDescription)
                this.getReportData()
        }

    },
    methods: {
        loadDescriptionsForFarm() {
            console.log('Running')
            this.loadingDescriptions = true;
            this.$newReq('GET', `reports/weekly/getJobDescriptions/${this.selectedFarm}`)
                .then((data) => {
                    console.log({data})
                    this.jobDescriptions = data
                })
                .catch(e => {
                    console.log(e)
                    this.$snack.netWorkError()
                })
                .finally(() => {
                    this.loadingDescriptions = false;
                })
        },

        setRangeDate(index) {
            console.log('Setting Date')
            if (index >= 0 && index <= this.maxTicks)
                this.$emit('update:viewStart', this.intervalsForYear[index].start)
        },

        getReportData() {
            this.reportData = [];
            this.loadingReportData = true;
            this.$newReq('POST', `reports/weekly`, {
                start: this.selectedRange.range.start,
                end: this.selectedRange.range.end,
                farm: this.selectedFarm,
                team: this.selectedDescription
            })
                    .then(data => {
                        this.reportData = data
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.loadingReportData = false
                    })
        },

        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/weekly/export`,
                    {
                        start: this.selectedRange.range.start,
                        end: this.selectedRange.range.end,
                        farm: this.selectedFarm,
                        team: this.selectedDescription,
                        farmDescription: this.farm.description
                    },
                    `${this.farm.description} ${this.selectedDescription || 'No Job Description'} Weekly Report ${format(this.selectedRange.range.start, 'MMdd')} - ${format(this.selectedRange.range.end, 'MMdd yyyy')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },


    computed: {
        ...mapGetters(['farmsRef']),

        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },

        rangeDisplay() {
            const selectedRange = this.intervalsForYear[this.selectedRangeIndex]

            return `${format(selectedRange.start, 'do MMM')} - ${format(selectedRange.end, 'do MMM')}`
        },

        intervalsForYear() {
            // Get the first Saturday from the beginning of the year
            let startDate = new Date(getYear(this.viewStart), 0, 1)
            while (getDay(startDate) !== 6)
                startDate = addDays(startDate, 1)
            // Get first friday after the end of the year
            let endDate = lastDayOfYear(this.viewStart)
            while (getDay(endDate) !== 5)
                endDate = addDays(endDate, 1)
            // Get All The Weeks In Between
            const intervals = eachWeekOfInterval({
                start: startDate,
                end: endDate
            }, {weekStartsOn: 6})
            return intervals.map((date) => {
                return {
                    start: date,
                    end: endOfDay(addDays(date, 6))
                }
            })
        },


        intervalLabels() {

            let lastAdded = null

            return this.intervalsForYear.reduce((list, interval) => {

                if (list.length === 0 || lastAdded !== format(interval.start, 'MMM')) {
                    lastAdded = format(interval.start, 'MMM')
                    list.push(lastAdded)
                } else {
                    list.push(null)
                }


                return list
            }, [])

        },


        selectedRange() {
            return this.intervalsForYear.reduce((res, range, index) => {
                if (!res && this.viewStart >= range.start && this.viewStart <= range.end) {
                    console.log('Assign')
                    return {range: range, index: index}
                }
                return res
            }, null)
        },

        selectedRangeIndex() {
            return this.selectedRange ? this.selectedRange.index : null
        },

        maxTicks() {
            return this.intervalsForYear.length - 1
        }
    }


}
</script>

<style scoped>

</style>